module.exports = __webpack_public_path__ + "static/media/calculator_placaj_klinker.4c8dc5bd.png";